import React, { useEffect, useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { getImages } from '../Const';

const PrintBuilder = ({ printRef, values }) => {

    const [formattedLocationValue, setFormattedLocationValue] = useState("");
    const [formattedPromoBannerValue, setFormattedPromoBannerValue] = useState("");

    // Function to format the address
    const formatAddress = (address) => {
        if (address.includes(",") && address.split(",").length >= 2) {
            const parts = address.split(",");

            const streetAndCity = parts[0].trim();
            const stateZip = parts[1].trim();

            const [state, zip] = stateZip.split(" ");

            const streetParts = streetAndCity.split(" ");

            const cityWordsCount = 2;
            const city = streetParts.slice(-cityWordsCount).join(" ");
            const street = streetParts.slice(0, -cityWordsCount).join(" ");

            return `${street}<br/>${city}, ${state} ${zip}`;
        }
        return address;
    };

    useEffect(() => {
        const formattedPromoBanner = formatAddress(values.promoBanner.value);
        const formattedLocation = formatAddress(values.locations.value);

        setFormattedPromoBannerValue(formattedPromoBanner);
        setFormattedLocationValue(formattedLocation);
    }, [values.promoBanner.value, values.locations.value]); // Trigger effect if either address changes
    return (
        <>
            {/* {console.log("values", values)} */}
            <div ref={printRef}>
                <div
                    style={{
                        padding: "15px 25px 30px",
                        backgroundColor: "transparent",
                        fontFamily: "Arial",
                        margin: "0 auto",
                        lineHeight: "normal",
                    }}
                >
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between",
                            opacity: "0",
                        }}
                    >
                        <div>
                            <img style={{ width: "165px" }} src={getImages('cardrop-pdf-logo.png')} />
                        </div>
                        <div>
                            <div
                                style={{
                                    fontSize: "46px",
                                    fontWeight: "900",
                                    letterSpacing: "-0.13px",
                                    textAlign: "right",
                                    color: "#666",
                                    textTransform: "uppercase",
                                    lineHeight: "60px",
                                }}
                            >Appraisal Offer</div>
                            <div
                                style={{
                                    fontSize: "23px",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontStyle: "normal",
                                    letterSpacing: "-0.19px",
                                    textAlign: "right",
                                    color: "#10758d",
                                    lineHeight: "30px",

                                }}
                            >www.cardropsouthflorida.com</div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex"
                        }}
                    >
                        <div
                            style={{
                                width: "520px",
                                paddingRight: "30px"
                            }}
                        >
                            <div
                                style={{
                                    border: "solid 1px transparent",
                                    marginTop: "30px"
                                }}
                            >
                                <div
                                    style={{
                                        padding: "9px 15px",
                                        backgroundColor: "#10758d",
                                        fontSize: "18px",
                                        lineHeight: "27px",
                                        fontWeight: "bold",
                                        letterSpacing: "-0.08px",
                                        color: "#fff",
                                        display: "flex",
                                        textTransform: "uppercase",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        opacity: "0",
                                    }}
                                >
                                    <div>Customer Info</div>
                                    <div>
                                        <span><img src={getImages('ap-info.svg')} /></span>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        padding: "10px 0",

                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        {values.full_name.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            width: "93px",
                                                            opacity: "0",
                                                        }}
                                                    >Name:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.full_name.fontSize + 'px',
                                                            // color: values.full_name.color,
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "4px 16px 4px 6px",
                                                            width: "338px",
                                                            textAlign: "right",
                                                            textTransform: "capitalize",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {values.full_name?.value?.toLowerCase()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {values.email.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            width: "93px",
                                                            opacity: "0",
                                                        }}
                                                    >Email:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.email.fontSize + 'px',
                                                            // color: values.email.color,
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            width: "338px",
                                                            textAlign: "right",
                                                            textTransform: "lowercase",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {values.email.value}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {values.phone.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            width: "37%",
                                                            opacity: "0",
                                                        }}
                                                    >Phone:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.phone.fontSize + 'px',
                                                            // color: values.phone.color,
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            width: "63%",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textAlign: "right",
                                                        }}
                                                    >{values.phone.value}</div>
                                                </div>
                                            </div>
                                        }
                                        {values.appraisal_date.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            width: "50%",
                                                            opacity: "0",
                                                        }}
                                                    >Date of Appraisal:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.appraisal_date.fontSize + 'px',
                                                            // color: values.appraisal_date.color,
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            width: "50%",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textAlign: "right",
                                                        }}
                                                    >{values.appraisal_date.value}</div>
                                                </div>
                                            </div>
                                        }
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                                opacity: "0",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    margin: "3px 0",

                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "15px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.06px",
                                                        color: "#10758d",
                                                        padding: "5px 6px 5px 16px",
                                                        textTransform: "uppercase",
                                                        paddingRight: "30px"
                                                    }}
                                                >Vehicle Information</div>
                                                <div
                                                    style={{
                                                        height: "1px",
                                                        background: "#cccccc",
                                                        width: "calc(100% - 240px)",
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        {/* Year: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        width: "37%",
                                                        opacity: "0",
                                                    }}
                                                >Year:</div>
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "4px 16px 5px 6px",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.year.value}</div>
                                            </div>
                                        </div>
                                        {/* Make: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        width: "37%",
                                                        opacity: "0",
                                                    }}
                                                >Make:</div>
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.make.value}</div>
                                            </div>
                                        </div>
                                        {/* Model: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        width: "37%",
                                                        opacity: "0",
                                                    }}
                                                >Model:</div>
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.model.value}</div>
                                            </div>
                                        </div>
                                        {/* Miles: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        width: "37%",
                                                        opacity: "0",
                                                    }}
                                                >Miles:</div>
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.mileage?.value === '0' ? "" : values.mileage?.value}</div>
                                            </div>
                                        </div>
                                        {/* VIN: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        width: "37%",
                                                        opacity: "0",
                                                    }}
                                                >VIN:</div>
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "27px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.vin.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    border: "solid 1px transparent",
                                    marginTop: "30px"
                                }}
                            >
                                <div
                                    style={{
                                        padding: "9px 15px",
                                        backgroundColor: "#10758d",
                                        fontSize: "18px",
                                        lineHeight: "27px",
                                        fontWeight: "bold",
                                        letterSpacing: "-0.08px",
                                        color: "#fff",
                                        display: "flex",
                                        textTransform: "uppercase",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        opacity: "0",
                                    }}
                                >
                                    <div>Appraisal Details</div>
                                </div>
                                <div
                                    style={{

                                        paddingTop: "14px",
                                        paddingBottom: "14px",

                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            padding: "0 15px"
                                        }}
                                    >
                                        <div
                                            style={{
                                                borderRight: "solid 1px transparent",
                                                flex: "0 0 auto",
                                                width: "50%",
                                            }}
                                        >

                                            {values.expiration_date.enabled &&
                                                <>
                                                    <div
                                                        style={{
                                                            fontSize: "18px",
                                                            lineHeight: "31px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#10758d",
                                                            textTransform: "uppercase",
                                                            marginBottom: "6px",
                                                            textAlign: "center",
                                                            opacity: "0",
                                                        }}
                                                    >Offer Valid Until</div>
                                                    <div
                                                        style={{
                                                            fontSize: "36px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.09px",
                                                            textAlign: "center",
                                                            minHeight: '50px',
                                                        }}
                                                    >{values.expiration_date.value}</div>
                                                </>
                                            }
                                        </div>
                                        {values.appraisal.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "50%",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "31px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#10758d",
                                                        textTransform: "uppercase",
                                                        marginBottom: "6px",
                                                        textAlign: "center",
                                                        opacity: "0",
                                                    }}
                                                >Appraisal Value</div>
                                                <div
                                                    style={{
                                                        fontSize: "36px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.09px",
                                                        textAlign: "center",
                                                    }}
                                                >{values.appraisal.value === '$0' ? "" : values.appraisal.value}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {values.vehicle_condition.enabled &&
                                <div
                                    style={{
                                        marginTop: "23px",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "21px",
                                            fontWeight: "bold",
                                            letterSpacing: "-0.08px",
                                            color: "#10758d",
                                            textTransform: "uppercase",
                                            marginBottom: "2px",
                                            lineHeight: "31px",
                                            opacity: "0",
                                        }}
                                    >Vehicle Condition</div>
                                    <div>
                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "#3f404c",
                                                fontWeight: "400",
                                                letterSpacing: "-0.06px",
                                                marginBottom: "5px",
                                                height: '46px',
                                                overflow: 'hidden',
                                                lineHeight: '22px',
                                                whiteSpace: 'pre-line',
                                            }}>{values.vehicle_condition.value}</div>
                                    </div>
                                </div>
                            }
                            {values.appraisal_note.enabled &&
                                <div
                                    style={{
                                        marginTop: "0",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "21px",
                                            fontWeight: "bold",
                                            letterSpacing: "-0.08px",
                                            color: "#10758d",
                                            textTransform: "uppercase",
                                            marginBottom: "2px",
                                            lineHeight: "31px",
                                            opacity: "0",
                                        }}
                                    >APPRAISAL DETAILS</div>
                                    <div>
                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "#3f404c",
                                                fontWeight: "400",
                                                letterSpacing: "-0.06px",
                                                marginBottom: "0",
                                                height: '84px',
                                                overflow: 'hidden',
                                                lineHeight: '20px',
                                                whiteSpace: 'pre-line',
                                            }}>{values.appraisal_note.value}</div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div
                            style={{
                                width: "260px",
                                minWidth: "260px",
                                opacity: "0",
                            }}
                        >
                            {values.locations.enabled &&
                                <>
                                    <div
                                        style={{
                                            border: "solid 1px transparent",
                                            marginTop: "30px",

                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "10px 15px",
                                                backgroundColor: "#10758d",
                                                fontSize: "16px",
                                                lineHeight: "23px",
                                                fontWeight: "bold",
                                                letterSpacing: "0.4px",
                                                color: "#fff",
                                                display: "flex",
                                                textTransform: "uppercase",
                                                alignItems: "center",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <div>Locations</div>
                                            <div>
                                                <span>
                                                    <img
                                                        style={{
                                                            maxWidth: "23px"
                                                        }}
                                                        src={getImages('pin.png')} />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                padding: "8px"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    lineHeight: "16px",
                                                    fontWeight: "bold",
                                                    letterSpacing: "-0.08px",
                                                    color: "#10758d",
                                                    textTransform: "uppercase",
                                                    marginBottom: "5px",
                                                }}
                                            >Boyton Beach</div>
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    lineHeight: "23px",
                                                    fontWeight: "400",
                                                    letterSpacing: "-0.06px",
                                                    color: "#3f404c",
                                                    marginBottom: "6px",
                                                }}
                                            >
                                                2027 High Ridge Road Boynton <br />Beach, FL 33426
                                            </div>
                                            <table
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}
                                                        >Mon - Sat:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>10:00am - 6:00pm</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Phone:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(561) 733-9919</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Fax:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(561) 733-8297</td>
                                                    </tr>
                                                </thead>
                                            </table>

                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    lineHeight: "16px",
                                                    fontWeight: "bold",
                                                    letterSpacing: "-0.08px",
                                                    color: "#10758d",
                                                    textTransform: "uppercase",
                                                    marginBottom: "5px",
                                                    marginTop: "19px"
                                                }}
                                            >POMPANO BEACH</div>
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    lineHeight: "23px",
                                                    fontWeight: "400",
                                                    letterSpacing: "-0.06px",
                                                    color: "#3f404c",
                                                    marginBottom: "6px",
                                                }}
                                            >
                                                3541 NW 14th Ave <br />Pompano Beach, FL 33064
                                            </div>
                                            <table
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Mon - Sat:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>10:00am - 6:00pm</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Phone:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(954) 366-1757</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Fax:</th>
                                                        <td
                                                            style={{
                                                                fontSize: "13px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(954) 247-9970</td>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            }
                            {values.promoBanner.enabled &&
                                <>
                                    <div
                                        style={{
                                            marginTop: "23px",

                                        }}
                                    >
                                        <img
                                            style={{
                                                width: "100%"
                                            }}
                                            src={getImages('ap-banner1.png')} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: "5px",

                        }}
                    >
                        <p
                            style={{
                                fontSize: "13px",
                                fontWeight: "normal",
                                lineHeight: "normal",
                                letterSpacing: "-0.04px",
                                color: "#999",
                                opacity: "0",
                            }}
                        >Disclaimer: All sales subject to final inspection</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrintBuilder
